export default __webpack_public_path__ + "static/IBMPlexSans-Text-Latin2-e1ba089fa0cd66daacbef840296a8853.woff2";